export interface Application {
	appliedAmount: number;
	appliedRepaymentTime: number; // number of months
	purpose: ApplicationPurpose;
	refinanceAmount: number;
}

export interface Applicant {
	nationalId: string;
	firstName?: string;
	lastName?: string;
	maritalStatus?: MaritalStatus;
	/**
	 * ISO country of the phone dial-code picker (e.g. `"SE"`). Client/UI only —
	 * never send to Goldfinger. Outbound mapping folds this into `mobileNumber`
	 * as E.164 (e.g. `+46701234567`).
	 */
	mobileCountry?: string;
	/** National in the form UI; E.164 when prepared for the API. */
	mobileNumber: string;
	emailAddress: string;
	numberOfChildrenBelow18?: number;
}

export interface Dwelling {
	type: DwellingType;
}

export interface Employment {
	type: EmploymentType;
	employer?: string;
	startDate?: Date;
	numberOfCars?: number;
}

export interface Expense {
	amount?: number;
	type: ExpenseType;
	period: Period;
}

export interface Income {
	/** Monthly income required for every employment type. */
	amount?: number;
	type: IncomeType;
	period: Period;
}

export interface Debts {
	mortgageLoan?: number;
	vehicleLoan?: number;
	studentLoan?: number;
	consumerLoan?: number;
}

export enum ApplicationPurpose {
	Car = "Car",
	Boat = "Boat",
	Caravan = "Caravan",
	MC = "MC",
	OtherVehicle = "OtherVehicle",
	BusinessLoan = "BusinessLoan",
	Refinance = "Refinance",
	Consolidation = "Consolidation",
	Renovation = "Renovation",
	Investment = "Investment",
	MedicalExpenses = "MedicalExpenses",
	VacationTravelling = "VacationTravelling",
	Wedding = "Wedding",
	Education = "Education",
	Invoices = "Invoices",
	Other = "Other",
}

export enum MaritalStatus {
	Single = "Single",
	Married = "Married",
	Divorced = "Divorced",
	Widower = "Widower",
	Separated = "Separated",
	CoHabiting = "CoHabiting",
}

export enum DwellingType {
	OwnHouse = "OwnHouse",
	OwnApartment = "OwnApartment",
	RentalApartment = "RentalApartment",
	HousingCooperative = "HousingCooperative",
	LivingWithParents = "LivingWithParents",
	CompanyHousing = "CompanyHousing",
	Other = "Other",
}

export enum EmploymentType {
	Furlough = "Furlough",
	Pensioner = "Pensioner",
	Incapacitated = "Incapacitated",
	FixedTermWorkContract = "FixedTermWorkContract",
	PermanentEmployment = "PermanentEmployment",
	Entrepreneur = "Entrepreneur",
	OtherEmployment = "Other",
	Student = "Student",
	WorkAssessmentAllowance = "WorkAssessmentAllowance",
	StayAtHome = "StayAtHome",
}

export enum ExpenseType {
	RentalCost = "RentalCost",
	Alimony = "Alimony",
	CarLeasing = "CarLeasing",
	HousingExpenses = "HousingExpenses",
	OtherExpenses = "OtherExpenses",
}

export enum IncomeType {
	GrossIncome = "GrossIncome",
	NetIncome = "NetIncome",
	PartnerGrossIncome = "PartnerGrossIncome",
	RentalIncome = "RentalIncome",
	InsuranceIncome = "InsuranceIncome",
	AlimonyIncome = "AlimonyIncome",
	GrossHouseholdIncome = "GrossHouseholdIncome",
	OtherIncome = "OtherIncome",
}

export enum Period {
	Monthly = "monthly",
	Quarterly = "quarterly",
	Yearly = "yearly",
}
